// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".s-canvas[data-v-57b3b10b]{border-radius:var(--base-size-4);overflow:hidden}.s-canvas #s-canvas[data-v-57b3b10b]{background-color:transparent}", ""]);
// Exports
module.exports = exports;
